import React from 'react';
import { FaLaptop, FaChalkboardTeacher, FaUsers } from 'react-icons/fa';
import { motion } from 'framer-motion';

const SmartLearning = () => {
  const features = [
    {
      title: 'Study Anytime and Anywhere',
      description: 'You don\'t have to attend our College campus, so you can study from anywhere in the world. Our online delivery enables you to download the lecture notes, submit assignments wherever you are. Our learning resources include web seminars and conferences, and discussion forums, as well as printed materials such as textbooks.',
      icon: <FaLaptop className="w-12 h-12 text-[#800000]" />
    },
    {
      title: 'Direct Faculty Interaction',
      description: 'All programmes come with direct faculty / lecturer support using discussion forum and dedicated chat support.',
      icon: <FaChalkboardTeacher className="w-12 h-12 text-[#800000]" />
    },
    {
      title: 'Discussion Forum',
      description: 'We enable you to be an independent learner, supported by your academic tutor, support staff and fellow students through an online community, using high-quality learning materials.',
      icon: <FaUsers className="w-12 h-12 text-[#800000]" />
    }
  ];

  // Animation variants
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.2,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    },
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <motion.div 
        className="bg-gradient-to-r from-primary to-primary-dark py-20 text-white"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 
            className="text-4xl md:text-5xl font-extrabold text-white mb-8"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            World's Best Online Education Experience
          </motion.h1>
          <motion.div 
            className="max-w-4xl mx-auto space-y-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            <p className="text-xl text-white">
              All our pre-masters and masters qualifications are recognised and well accepted around the world – from universities to equivalent bodies and employers worldwide.
            </p>
            <p className="text-xl text-white">
              Our unique learning methodology enables you to complete your programmes at your own pace and your time...
            </p>
          </motion.div>
        </div>
      </motion.div>

      {/* About Smart Learning Section */}
      <motion.div 
        className="py-16 bg-white"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={container}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            className="text-center mb-16"
            variants={item}
          >
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl mb-6">
              About Smart Learning
            </h2>
          </motion.div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {features.map((feature, index) => (
              <motion.div 
                key={index}
                className="bg-white p-8 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 flex flex-col h-full"
                variants={item}
                whileHover={{ scale: 1.02 }}
              >
                <div className="flex justify-center mb-6">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-center flex-grow">
                  {feature.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default SmartLearning;
